import React, { useState } from "react";
import TabContentAccordionWebView from './TabContentsAccordionWebView'
import TabContentAccordionMobileView from './TabContentsAccordionMobileView'

const TabContentAccordion = (props) => {
  return (
    <>
      {/* any change or fix to this file should be done in both file, it is duplicate component for mobile and web view */}
      <TabContentAccordionWebView props={props} />
      <TabContentAccordionMobileView props={props} />
    </>
  )
}

export default TabContentAccordion;